import { SelectableOption } from '../form-utils/selectable-option.type';
import { BoxShadowConfig } from '../shared/box-shadow/box-shadow.interface';
import { SpacingConfig } from '../shared/spacing/spacing.interface';
import { RadioDirection } from './radio-component-direction.enum';

export interface RadioConfig {
  options?: SelectableOption[];
  cssStyle?: { [key: string]: any };
  cssClass?: string;
  invalidConfigText?: string;
  shadowSettings?: BoxShadowConfig;
  paddingSettings?: SpacingConfig;
  marginSettings?: SpacingConfig;
  color?: string;
  width?: string;
  height?: string;
  showOptionsAsButtons?: boolean;
  direction?: RadioDirection;
}
